<template>
  <i-sidebar v-model="sidebar" :collapse="true" collapse-position="absolute" placement="right" am-sidebar>
    <i-nav vertical>
      <i-collapsible v-model="isOpen" accordion>
        <i-collapsible-item
          v-for="category in categories"
          :key="category.code"
          :name="category.code"
          :title="category.name"
        >
          <i-nav-item
            v-for="subCategory in category.subCategories"
            :key="subCategory.code"
            :to="navRoute(subCategory, category)"
            :active="$route.params.table === subCategory.code"
          >
            {{ subCategory.name }}
          </i-nav-item>
        </i-collapsible-item>
        <i-collapsible-item
          v-if="$store.getters.isAdmin"
          title="Admin"
          name="admin"
        >
          <i-nav-item
            to="/admin/invites"
            :active="$route.path === '/admin/invites'"
          >
            Invites
          </i-nav-item>
          <i-nav-item
            to="/admin/create-invite"
            :active="$route.path === '/admin/create-invite'"
          >
            Create invite
          </i-nav-item>
          <i-nav-item
            to="/admin/users"
            :active="$route.path === '/admin/users'"
          >
            Users
          </i-nav-item>
        </i-collapsible-item>
      </i-collapsible>
    </i-nav>
    <i-card am-sidebar-buttons>
      <ThemeToggle />
      <i-tooltip placement="top">
        <i-button outline color="danger" size="md" @click="logout()">
          <svg viewBox="0 0 24 24" width="28" height="28" class="inkline-icon">
            <use xlink:href="@/assets/icons.svg#logout" x="0" y="0" width="28" height="28"></use>
          </svg>
        </i-button>
        <template #body>Logout</template>
      </i-tooltip>
    </i-card>
  </i-sidebar>
</template>

<script>
import ThemeToggle from './ThemeToggle'

import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'TheSidebar',
  components: {
    ThemeToggle
  },
  computed: {
    ...mapState('partCategories', { categories: state => state.data }),
    ...mapState('ui', { sidebarState: state => state.sidebar }),
    sidebar: {
      get () { return this.sidebarState },
      set (val) { this.setSidebarState(val) }
    },
    isOpen () {
      const code = []
      if (this.$route.path.includes('admin')) {
        code.push('admin')
      } else code.push(this.$route.params.db)
      return code
    }
  },
  async created () {
    if (!this.categories.length) {
      await this.getPartCategories()
      if (this.$route.params.db) {
        this.setCategories(this.$route.params)
      }
    }
  },
  methods: {
    ...mapMutations('ui', ['setSidebarState']),
    ...mapActions('partCategories', ['getPartCategories', 'setCategories']),
    navRoute (subCat, cat) {
      if (this.$route.path.includes('instructions')) {
        return `/instructions/${subCat.parent}/${subCat.code}/${subCat.subCategories[0].id}-${subCat.subCategories[0].code}-${subCat.id}-${cat.id}`
      } else return `/db/${subCat.parent}/${subCat.code}/${subCat.subCategories[0].id}-${subCat.subCategories[0].code}-${subCat.id}-${cat.id}`
    },
    logout () {
      this.sidebar = false
      this.$store.dispatch('logout')
        .then(() => this.$router.push('/'))
    }
  },
  mounted () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) this.setSidebarState(false)
    })
  }
}
</script>

<style lang="scss">
  [am-sidebar] {

    .sidebar-content {
      justify-content: space-between;
    }

    [am-sidebar-buttons] {
      .card-body {
        justify-content: space-between;
        display: flex;
      }
    }
  }
</style>
